<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :canAddNew="!canAdd" :items="items" />
    <!-- End Breadcrumb -->
    <!-- Start Statistics Card-->

    <!-- Start Main Loader -->
    <transition name="fadeInUp" mode="out-in" v-if="loaderPage">
      <!-- <MainLoader /> -->
    </transition>
    <!-- End Main Loader -->
    <div class="fadeIn" v-else>
      <!-- <div class="row mb-5">
        <div class="wrraper">
          <stats-card
            :title="$t('countriesNum')"
            :number="statisticsItem.number"
          ></stats-card>
        </div>
      </div> -->
      <!-- End Statistics Card-->
      <template>
        <!-- Start Main Section -->
        <main>
          <div :class="{ 'col-lg-8': selectedItem }">
            <v-data-table
              class="elevation-1 thumb diff_table"
              :headers="headers"
              :items="rows"
              :search="search"
              :custom-filter="helper_filterSearch"
              :loading="loading"
              :loading-text="$t('table.loadingData')"
              item-key="id"
              :items-per-page="paginations.items_per_page"
              hide-default-footer
            >
              <!-- ================== You Can use any slots you want ================== -->
              <!-- Select no data State -->
              <template v-slot:no-data>
                {{ $t("table.noData") }}
              </template>
              <!-- index -->
              <template v-slot:[`item.index`]="{ index }">
                {{ index + 1 }}
              </template>
              <!-- avatar -->
              <template v-slot:[`item.flag`]="{ item }">
                <img
                  class="tw-mx-auto tw-object-cover"
                  width="70"
                  height="70"
                  :src="item.flag"
                /> </template
              >0
              <template v-slot:[`item.phone_code`]="{ item }">
                {{ item.phone_code }}
              </template>
              <!-- Select actions-->
              <template v-slot:[`item.actions`]="{ item }">
                <div class="_actions">
                  <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
                  <v-icon
                    class="edit"
                    v-if="!canEdit"
                    small
                    @click="editItem(item)"
                  >
                    fal fa-edit
                  </v-icon>
                  <v-icon
                    class="delete"
                    v-if="!canDelete"
                    small
                    @click="deleteItem(item)"
                  >
                    fal fa-trash
                  </v-icon>
                </div>
              </template>

              <!-- ======================== Start Top Section ======================== -->
              <template v-slot:top>
                <h3 class="title table-title">أكواد الدول</h3>
                <!-- Delete dialog -->
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5 justify-center">
                      {{ $t("table.deletedialog.areYouSure") }}
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#1B5E20" @click="deleteItemConfirm">
                        {{ $t("table.deletedialog.ok") }}
                      </v-btn>
                      <v-btn color="#F44336" @click="dialogDelete = false">
                        {{ $t("table.deletedialog.cancel") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Add & Delete -->
                <v-row>
                  <v-col cols="12" sm="8"></v-col>
                </v-row>
              </template>
              <!-- ======================== End Top Section ======================== -->
            </v-data-table>
            <!-- Start Pagination -->
            <template>
              <div
                class="pagination_container tw-text-center mb-5 d-flex justify-content-between"
              >
                <!-- <div class="select-pagination d-flex">
                    <span class="first">{{ $t('show') }}</span>
                    <v-select
                      :items="[5, 20, 50, 100]"
                      v-model="paginations.items_per_page"
                    ></v-select>
                    <span>{{ $t('entries') }}</span>
                  </div> -->

                <v-pagination
                  v-model.number="paginations.current_page"
                  :length="paginations.last_page"
                  :total-visible="5"
                  @input="fetchData($event)"
                ></v-pagination>
              </div>
            </template>
          </div>
          <div class="edit_phone_code col-lg-4" v-if="selectedItem">
            <div>
              <v-icon color="red" @click="selectedItem = null">
                mdi-close
              </v-icon>
              <form @submit.prevent="validateCreateForm">
                <div class="container">
                  <div class="row justify-content-between">
                    <div class="col-12 row justify-content-center">
                      <div class="col-lg-12 col-md-6">
                        <div class="upload_input_wrapper col-9">
                          <uplode-image
                            :data_src="selectedItem.flag"
                            @inputChanged="uplodeImg_1"
                            placeHolder="علم الدولة "
                          ></uplode-image>
                        </div>
                        <!-- End:: Flag Input -->
                      </div>
                    </div>
                    <div class="col-lg-12 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          @keypress="isArabic"
                          v-model.trim="selectedItem.alt_image_ar"
                        />
                        <label for="name_input" class="form-label"
                          >النص البديل للصورة (عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-12 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          @keypress="isEnglish"
                          v-model.trim="selectedItem.alt_image_en"
                        />
                        <label for="name_input" class="form-label"
                          >النص البديل للصورة (إنجليزي)</label
                        >
                      </div>
                    </div>
                    <!-- Start:: Ar title -->
                    <div class="col-lg-12 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="selectedItem.title_ar"
                        />
                        <label for="name_input" class="form-label">
                          اسم الدولة (عربي)
                        </label>
                      </div>
                    </div>
                    <!-- End:: Ar title -->

                    <!-- Start:: En title -->
                    <div class="col-lg-12 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="selectedItem.title_en"
                        />
                        <label for="name_input" class="form-label">
                          أسم الدولة (انجليزي)
                        </label>
                      </div>
                    </div>
                    <!-- End:: En title -->

                    <!-- Start:: En code -->
                    <div class="col-lg-12 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="selectedItem.phone_code"
                        />
                        <label for="name_input" class="form-label">
                          كود الدولة
                        </label>
                      </div>
                    </div>
                    <!-- End:: En code -->
                  </div>
                  <div class="buttons_wrapper">
                    <button class="base-btn">
                      {{ $t("forms.submit") }}
                      <span class="btn_loader" v-if="btnIsLoading"></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </main>
        <!-- End Main Section -->
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // ========== Main Loader
      loaderPage: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.phone_codes.title"),
          disabled: false,
          href: "/phone-codes",
        },
        {
          text: this.$t("breadcrumb.phone_codes.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      selectedItem: null,
      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Loding
      loading: false,
      btnIsLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: " الصورة",
            align: "center",
            value: "flag",
            sortable: false,
          },
          {
            text: "الدولة ",
            align: "center",
            value: "title_ar",
            sortable: false,
          },
          {
            text: "الكود ",
            align: "center",
            value: "phone_code",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "Image",
            align: "center",
            value: "flag",
            sortable: false,
          },
          {
            text: "Link",
            align: "center",
            value: "title_ar",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },
    uplodeImg_1(obj) {
      this.selectedItem.flag = obj;
    },
    // img Model
    editItem(item) {
      // this.model_1.model_img_src = e.target.src
      // this.model_1.show_model = true
      this.selectedItem = item;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/phone-codes/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/phone-codes/show/" + item.id });
    },
    // editItem(item) {
    //   this.$router.push({ path: '/phone-codes/edit/' + item.id })
    // },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `phone_code/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      this.loaderPage = true;
      const params = new URLSearchParams();
      params.append("page", this.paginations.current_page);

      this.axios({
        method: "GET",
        url: "phone_code",
        params: params,
        // params: {
        //   page: this.paginations.current_page,
        //   keyword: e?.searchInput ? e.searchInput : '',
        // },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;
          // console.log(res.data.data)
          this.statisticsItem.number = res.data.meta.total;

          this.loaderPage = false;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
    // Start Edits Function
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      console.log(this.data);
      if (!this.selectedItem.title_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل اسم الدولة بالعربي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.selectedItem.title_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل اسم الدولة بالانجليزي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.selectedItem.flag) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل علم الدولة ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.selectedItem.phone_code) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل كود الدولة ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.editData();
        return;
      }
    },

    // Submit Data
    editData() {
      const submit_data = new FormData();
      if (this.selectedItem.flag.img_file) {
        submit_data.append("flag", this.selectedItem.flag.img_file);
      }
      if (this.selectedItem.alt_image_ar) {
        submit_data.append(`ar[alt_image]`, this.selectedItem.alt_image_ar);
      }
      if (this.selectedItem.alt_image_en) {
        submit_data.append(`en[alt_image]`, this.selectedItem.alt_image_en);
      }
      // submit_data.append(`ar[alt_image]`,  this.selectedItem.alt_image_ar)
      // submit_data.append(`en[alt_image]`,  this.selectedItem.alt_image_en)
      submit_data.append("ar[title]", this.selectedItem.title_ar);
      submit_data.append("en[title]", this.selectedItem.title_en);
      // submit_data.append('flag',  this.selectedItem.flag ?? this.selectedItem.flag.img_file )
      submit_data.append("phone_code", this.selectedItem.phone_code);
      submit_data.append("_method", "PUT");
      this.axios({
        method: "POST",
        url: `phone_code/${this.selectedItem.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.selectedItem = null;
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
  created() {
    this.canEdit = this.$permission.allowed("phone-codes/edit/");
    this.canDelete = this.$permission.allowed("phone-codes/delete");
    this.canAdd = this.$permission.allowed("phone-codes/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },

  // ======= hooks
};
</script>

<style lang="scss" scoped>
.edit_phone_code {
  @include mainShadow;
  border-radius: 15px;
  height: 100vh;
}
.flag_image {
  width: 60px;
  border-radius: 4px;
  height: 60px;
  object-fit: cover;
}
</style>
